import { useState } from "react";
import { Shield, CheckCircle2 } from "lucide-react";
import PolicyEditModal from "./PolicyEditModal";

var STATUS_MAP = {
  ativa: { cls: "bg-emerald-100 text-emerald-700", label: "Ativa" },
  vencida: { cls: "bg-red-100 text-red-700", label: "Vencida" },
  cancelada: { cls: "bg-gray-200 text-gray-600", label: "Cancelada" },
  pendente: { cls: "bg-amber-100 text-amber-700", label: "Pendente" },
};

function formatCurrency(v) {
  if (v == null || v === 0) return "R$ 0";
  return "R$ " + Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2 });
}

function formatDate(d) {
  if (!d) return "-";
  try { return new Date(d).toLocaleDateString("pt-BR"); } catch(e) { return d; }
}

export default function PoliciesSection({ policies, onRefresh }) {
  var selectedState = useState(null);
  var selected = selectedState[0];
  var setSelected = selectedState[1];

  if (!policies || policies.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-testid="profile-policies-section">
        <h2 className="text-base font-bold text-[#0A2F3D] mb-3 flex items-center gap-2"><Shield className="w-5 h-5 text-[#3B82F6]" />Apolices de Seguro</h2>
        <p className="text-sm text-gray-400 text-center py-6">Nenhuma apolice vinculada</p>
      </div>
    );
  }

  function handleRowClick(p) {
    setSelected(p);
  }

  function handleClose() {
    setSelected(null);
  }

  function handleSaved() {
    setSelected(null);
    if (onRefresh) onRefresh();
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6" data-testid="profile-policies-section">
      <h2 className="text-base font-bold text-[#0A2F3D] mb-4 flex items-center gap-2">
        <Shield className="w-5 h-5 text-[#3B82F6]" />Apolices de Seguro
        <span className="ml-auto text-xs font-normal text-gray-400">{policies.length} registro{policies.length !== 1 ? "s" : ""}</span>
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="profile-policies-table">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50/50">
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Numero</th>
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Seguradora</th>
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Tipo</th>
              <th className="text-right py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Premio</th>
              <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Vigencia</th>
              <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Status</th>
            </tr>
          </thead>
          <tbody>
            {policies.map(function(p) {
              var st = STATUS_MAP[p.status] || { cls: "bg-gray-100 text-gray-600", label: p.status };
              return (
                <tr key={p.id}
                  onClick={function() { handleRowClick(p); }}
                  className="border-b border-gray-50 hover:bg-[#3B82F6]/5 cursor-pointer transition-colors"
                  data-testid={"profile-policy-" + p.id}>
                  <td className="py-2.5 px-3 font-medium text-[#0A2F3D]">{p.policy_number || "-"}</td>
                  <td className="py-2.5 px-3 text-gray-600">{p.insurer_name || "-"}</td>
                  <td className="py-2.5 px-3 text-gray-500 hidden sm:table-cell">{p.insurance_type || "-"}</td>
                  <td className="py-2.5 px-3 text-right text-gray-600 hidden md:table-cell">{formatCurrency(p.premium)}</td>
                  <td className="py-2.5 px-3 text-center text-gray-500 text-xs hidden md:table-cell">{formatDate(p.start_date)} - {formatDate(p.end_date)}</td>
                  <td className="py-2.5 px-3 text-center">
                    <span className={"px-2 py-0.5 text-xs font-medium rounded-full inline-flex items-center gap-1 " + st.cls}>
                      <CheckCircle2 className="w-3 h-3" />{st.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="text-[10px] text-gray-400 mt-2 text-center">Clique em uma linha para ver detalhes e editar</p>

      {selected && (
        <PolicyEditModal
          policy={selected}
          open={!!selected}
          onClose={handleClose}
          onSaved={handleSaved}
        />
      )}
    </div>
  );
}
